export default {
	install: (Vue) => {
		Vue.prototype.$onReload = function (callback) {
			this.$ls.on('reloadCounter', callback);
		};
		Vue.prototype.$triggerReload = function () {
			this.$ls.set('reloadCounter', this.$ls.get('reloadCounter', 0)+1);
			this.$modalBus.$emit('RELOAD', '');
		};

		Vue.prototype.$onTourReload = function (callback) {
			this.$ls.on('reloadTourCounter', callback);
		};
		Vue.prototype.$triggerTourReload = function () {
			this.$ls.set('reloadTourCounter', this.$ls.get('reloadTourCounter', 0)+1);
		};
	}
};
